<template>
  <el-main class="container">
    <Nav>
      <div slot="left">
        <el-input placeholder="请输入标签名称进行搜索" v-model="body.word" clearable></el-input>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
      </div>
      <div slot="right">
        <el-button v-show="hasAuthority('addProjectTag')" type="primary" @click="handleAdd">新增标签</el-button>
      </div>
    </Nav>
    <div class="table-box">
      <Table
        border
        align="center"
        :column="tableInfo.column"
        :data="tableInfo.data"
        :header-row-style="{height: '100px'}"
        :header-cell-style="{background:'#f4f4f4',color:'#606266'}"
        :row-style="{height: '100px'}"
        pagination
        background
        :paginationTop="'30px'"
        :paginationAlign="'center'"
        layout="prev, pager, next, sizes, jumper"
        :page-sizes="[5, 10, 20, 30]"
        :pager-count="5"
        :current-page.sync="body.pageIndex"
        :total="tableInfo.total"
        :page-size="body.pageSize"
        @size-change="handleSizeChange"
        @p-current-change="handleCurrentChange"
      ></Table>
    </div>
  </el-main>
</template>

<script>
import {
  getTagList,
  deleteTag
} from '@/api/featured'
export default {
  data() {
    return {
      tableInfo: {
        column: [
          {
            prop: 'indexNum',
            label: '排列序号'
          },
          {
            prop: 'name',
            label: '标签名称'
          },
          {
            label: '操作',
            render: (h, row) => {
              return (
                <div>
                  <el-link v-show={this.hasAuthority('editProjectTag')} underline={false} type='primary' onClick={() => { this.handleEdit(row) }}>编辑</el-link>&nbsp;&nbsp;
                  <el-link v-show={this.hasAuthority('deleteProjectTag')} underline={false} type='primary' onClick={() => { this.handleDelete(row) }}>删除</el-link>&nbsp;&nbsp;
                </div>
              )
            }
          }
        ],
        data: [],
        total: 0
      },
      body: {
        pageSize: 10,
        pageIndex: 1,
        word: ''
      }
    }
  },
  created() {
    this.network().getTagList()
  },
  methods: {
    network() {
      return {
        getTagList: async() => {
          const { data } = await getTagList(this.body)
          this.tableInfo.total = data.total
          this.tableInfo.data = data.list
        },
        deleteTag: async(id) => {
          await deleteTag(id)
          this.$message.success('删除成功')
          this.body.pageIndex = 1
          this.network().getTagList()
        }
      }
    },
    handleAdd() {
      this.$router.push('/project-tag-list/add')
    },
    handleEdit(scoped) {
      this.$router.push({
        path: '/project-tag-list/set',
        query: {
          info: JSON.stringify(scoped.row)
        }
      })
    },
    handleDelete(scoped) {
      this.$confirm('是否删除该标签？', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.network().deleteTag(scoped.row.uuid)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleSizeChange(size) {
      this.body.pageSize = size
      this.network().getTagList()
    },
    handleCurrentChange(page) {
      this.body.pageIndex = page
      this.network().getTagList()
    },
    handleSearch() {
      this.network().getTagList()
    }
  }
}
</script>

<style>

</style>
